import {Paper, Pagination} from '@mantine/core';
import {ExecutionsPaginationType} from 'src/types';

type ExecutionPaginationProps = {
    executionsPagination: ExecutionsPaginationType;
    onPaginationChange?: (page: number) => void;
};

export function ExecutionPagination({executionsPagination, onPaginationChange}: ExecutionPaginationProps) {
    return (
        <Paper
            shadow="md"
            style={{
                margin: 'auto',
                display: 'flex',
                justifyContent: 'center',
                paddingTop: '0.75rem',
                paddingBottom: '0.75rem',
            }}
        >
            <Pagination total={executionsPagination.totalPages} onChange={onPaginationChange} />
        </Paper>
    );
}
